import { render, staticRenderFns } from "./legend-test.vue?vue&type=template&id=dfeff49e&scoped=true"
import script from "./legend-test.vue?vue&type=script&lang=js"
export * from "./legend-test.vue?vue&type=script&lang=js"
import style0 from "./legend-test.vue?vue&type=style&index=0&id=dfeff49e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfeff49e",
  null
  
)

export default component.exports